import * as React from 'react';
// Page entity is the Entity which is the primary focus of the page, that is, it should ALWAYS resolve to
// the entity which is used by a static site generator to render the "web page". 
// This can be different from the "Active entity", which can be overridden to allow navigation
// to show a different page for the active state, and also the "current entity from `useEntity`" which
// can be a Slice INSIDE the page, for example.
export var PageEntityContext = React.createContext(null);
export var PageEntityProvider = function (_a) {
  var value = _a.value,
    children = _a.children;
  return React.createElement(PageEntityContext.Provider, {
    value: value
  }, children);
};